<div class="password-container">
  <gen-dynamic-form
    class="dynamic-form-container"
    [formConfig]="dynamicFormConfig"
    [mode]="'text'"
    [disabled]="true"
    [formData]="formData"
    [listenToDataChange]="true"
  ></gen-dynamic-form>
  <section>
  <gen-button *ngIf="!widgetDisabledStatus && !readOnly"
    [type]="'quite'"
    [iconClass]="'icon__edit'"
    (click)="openEncryptForm()">
  </gen-button>  
  <gen-button *ngIf="passwordExists"
    [type]="'quite'"
    [iconClass]="'icon__Show fs4_5'"
    (click)="openDecryptForm()">
  </gen-button>   
</section>
</div>


